module.exports = __webpack_public_path__ + "static/media/alertsinbox.543f1185.png";